<template>
  <div class="flex justify-center">
    <checkbox-field v-if="enabled" v-model="_value" :disabled="!enabled" />
    <span v-else class="h-4 w-4 border rounded" />
  </div>
</template>

<script setup lang="ts">
import { computed } from 'vue'

import {
  CheckboxField,
} from '@/components/fields'

interface Props {
  value?: boolean | null
  default?: boolean | null
  enabled?: boolean
}

const props = withDefaults(defineProps<Props>(), {
  value: null,
  default: null,
  enabled: true,
})

const emit = defineEmits<{
  (e: 'change', value: boolean): void
}>()

const _value = computed({
  get () {
    return props.value ?? props.default ?? false
  },
  set (value) {
    emit('change', value)
  },
})
</script>
